module.exports = __webpack_public_path__ + "media/images/flags/4x3/mnp-f433286690ac33ad7116d80f44bc261c.svg";